import { CalculationUtils } from './../../@core/utils/calculation-utils';
import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChildren
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { PosSupervisorLoginService } from 'src/app/@core/services/pos-supervisor-login.service';
import { DateUtils } from 'src/app/@core/utils/date-utils';
import { ColumnTable } from 'src/app/models/column-table';
import { FilterTable } from 'src/app/models/filter-table';
import { GroupedFilterTable } from 'src/app/models/grouped-filter';
import { Paging } from 'src/app/models/page';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'pos-table',
  templateUrl: './pos-table.component.html',
  styleUrls: ['./pos-table.component.sass'],
})
export class PosTableComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private authService: AuthService,
    private supervisorService: PosSupervisorLoginService
  ) { }

  @ViewChildren(TemplateRef) templates!: QueryList<TemplateRef<any>>;

  @Input()
  public headers: Array<ColumnTable> = [];

  @Input()
  public filters: Array<FilterTable> = [];

  @Input()
  public data: Paging<Array<any>> = new Paging([]);

  @Input()
  public badgeSuccessValues: Array<string> | string = [];
  @Input()
  public badgeWarningValues: Array<string> | string = [];
  @Input()
  public badgeSecondaryValues: Array<string> | string = [];
  @Input()
  public badgeDangerValues: Array<string> | string = [];

  @Input()
  public itemsPerPage: number = 20;

  @Input()
  public tableFormId: string = 'tf';

  @Input()
  public pagination: boolean = true;

  @Output()
  public dataChange = new EventEmitter<any>();

  @Output()
  public dataSave = new EventEmitter<any>();

  @Output()
  public rowClick = new EventEmitter<any>();

  public currentPage = 1;

  public filterForm?: FormGroup;
  public tableForm?: FormGroup;
  public Object = Object;
  private isFiltered = false;

  public currentIndex?: number;

  @Output()
  public getTableForm = new EventEmitter();

  @Output()
  public updateSecondaryDatasources = new EventEmitter();

  @Output()
  public getTableFormInvalid = new EventEmitter();

  @Input()
  public disableHighlight: boolean = false;

  @Input()
  public highlightSuccessDangerField: string = "";

  @Input()
  public showRefreshButton = false;

  @Input()
  public isGroupedFilters = false;

  @Input()
  public groupedFilters: Array<GroupedFilterTable> = [];

  @Input()
  public selectedRowsCache: Array<any> = [];

  @Input()
  public idFieldToCheckSelectedCache: string = "";

  private popOversToHide: Array<PopoverDirective> = [];




  ngOnInit(): void {
    if (this.filters.length > 0) {
      let filterColumns = this.filters.reduce(
        (ac, a) => ({ ...ac, [a.code]: '' }),
        {}
      );
      this.filterForm = this.formBuilder.group(filterColumns);
    }

    if (this.groupedFilters.length > 0) {
      let filterColumns = this.groupedFilters.flatMap(f => f.filters).reduce(
        (ac, a) => ({ ...ac, [a.code]: '' }),
        {}
      );
      this.filterForm = this.formBuilder.group(filterColumns);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.headers &&
      changes.headers.isFirstChange() &&
      changes.headers.currentValue.length > 0
    ) {
      this.updateTable();
    }
    if (
      changes.data &&
      !changes.data.isFirstChange() /*&& changes.data.currentValue.content.length > 0*/
    ) {
      this.updateTable();
      this.onSubmit();
      // if (!this.isEqual(changes.data.previousValue.content, changes.data.currentValue.content)) {

      // }
    }
  }

  updateTable() {
    let tableArray = new Map<any, any>();
    this.data.content.forEach((f, dataIndex) => {
      this.headers.forEach((h, headerIndex) => {
        let value = f[h.code];

        if (h.code.includes(".")) {
          let tempCode = h.code.split(".");
          tempCode.forEach(x => {
            if (value) {
              value = value[x]
            }
            else {
              value = f[x]
            }
          })
        }
        let required = h.required
          ? Validators.required
          : Validators.nullValidator;
        let formControl = new FormControl(value, required);
        if (h.type == 'date') {
          formControl = new FormControl(
            this.datePipe.transform(value, 'yyyy-MM-dd'),
            required
          );
        }

        if (h.type == 'number' && h.editable && h.required) {
          if (h.max) {


            formControl = new FormControl(value, [Validators.min(0.01), Validators.max(CalculationUtils.round(f[h.fieldToSetMax])), required]);

          } else {

            formControl = new FormControl(value, [Validators.min(0.01), required]);
          }
        }



        if (h.editable) {
          if (h.disableSwitchFn(f)) {
            formControl.disable();
          }
        }

        if (h.justEditLastOne) {
          if (!f.isLastOne) {
            formControl.disable();
          }
        }
        tableArray.set(`${h.code.replace(".", "-")}-${dataIndex}-${headerIndex}`, formControl);

        if (h.type == 'switch') {
          const fieldsNamesToCheckSelectedCache = this.headers.filter(header => header.useToFieldToCheckSelectedCache).map(field => field.code);
          if (this.selectedRowsCache.length > 0 && fieldsNamesToCheckSelectedCache.length > 0) {
            const isSelected = fieldsNamesToCheckSelectedCache.reduce((acc, act) => acc && this.selectedRowsCache.findIndex(rc => rc[act] == f[act]) != -1, true);
            formControl.setValue(isSelected);
          }
        }
      });
    });

    let selectedAllSwitchValues = new Map<string, boolean>();
    if (this.tableForm) {
      this.headers.filter(f => f.selectedAllSwitch).forEach(f => {
        selectedAllSwitchValues.set(f.code, this.tableForm?.get(`${f.code}-selectedAllSwitch`)?.value || false)
      })
    }
    this.tableForm = this.formBuilder.group(Object.fromEntries(tableArray));
    this.headers.filter(f => f.selectedAllSwitch).forEach(f => {
      this.tableForm?.addControl(`${f.code}-selectedAllSwitch`, new FormControl(selectedAllSwitchValues.get(f.code)))
    });
  }

  public getRowData(item: any, field: ColumnTable) {
    let itemValue = item[field.code];
    if (field.code.includes(".")) {
      let tempCode = field.code.split(".");
      tempCode.forEach(x => {
        if (itemValue) {
          itemValue = itemValue[x]
        }
        else {
          itemValue = item[x]
        }
      })
    }
    if (field.type == "date") {
      switch (field.dateType) {
        case "dateFromString":
          itemValue = DateUtils.getDateFromString(itemValue);
          break;
        // case "dateAndTimeFromString":
        // itemValue = DateUtils.getDateAndTimeFromString(itemValue);
        // break;
        default:
          break;
      }
    }

    let itemValueString = itemValue;
    if (itemValue != undefined)
      itemValueString = itemValue.toString();
    return field.valueMap.get(itemValueString) || itemValue;
  }

  public obtainBadgeClass(header: ColumnTable, item: any) {
    let value = item[header.code];
    if (header.code.includes(".")) {
      let tempCode = header.code.split(".");
      tempCode.forEach(x => {
        if (value) {
          value = value[x]
        }
        else {
          value = item[x]
        }
      })
    }
    if (this.badgeSuccessValues.includes(value)) {
      return 'badge badge-success';
    } else if (this.badgeWarningValues.includes(value)) {
      return 'badge badge-warning';
    } else if (this.badgeSecondaryValues.includes(value)) {
      return 'badge badge-secondary';
    } else if (this.badgeDangerValues.includes(value)) {
      return 'badge badge-danger';
    }

    return 'badge badge-success';
  }

  public pageSelected(event: any) {
    this.filterAction(event.page - 1);
  }

  public filterAction(page?: number, filter?: FilterTable, event?: any, fromClearFilters?: boolean) {

    let value = {
      value: this.filterForm ? this.filterForm.value : {},
      page: page != undefined ? page : this.currentPage - 1,
      pageSize: this.itemsPerPage,
    };
    this.dataChange.emit(value);
    this.updateTable();
    if (filter?.hasDependecyComboBox || fromClearFilters === true) {
      this.updateSecondaryDatasources.emit({ filter, selectedValue: event?.target.value });
    }
    //this.isFiltered = true;
  }
  trackByIndex(index: number, value: any) {
    return index;
  }

  trackByValue(custom: any, index: number, value: any) {
    return custom;
  }

  onSubmit(): void {
    let resultArray = this.getResultArray();
    this.dataSave.emit(resultArray);

    if (resultArray.length > 0) {
      this.tableForm?.markAsTouched();
      this.tableForm?.markAsDirty();
    } else {
      this.tableForm?.markAsUntouched();
      this.tableForm?.markAsPristine();
    }
    this.getTableForm.emit(this.tableForm);
  }

  public getResultArray() {
    let result = this.getTableDataMap();
    let resultArray = Array.from(result.values());
    return resultArray;
  }

  rowFn(value: any, itemIndex: number) {
    this.currentIndex = itemIndex;
    this.rowClick.emit(value);
  }

  getTableDataMap(): Map<any, any> {
    //{'2000', Object}

    let result = Object.keys(this.tableForm?.getRawValue());
    let map = new Map<any, any>();
    result.forEach((f) => {
      let a = f.split('-')[0];
      let b = f.split('-')[1];

      let val = map.get(b) || {};

      Object.assign(val, { [a]: this.tableForm?.getRawValue()[f] });
      map.set(b, val);
    });

    return map;
  }

  isEqual(previous: any, current: any) {
    let previousArray = previous as any[];
    let currentArray = current as any[];
    let result = true;
    let headerCodes = this.headers.map((h) => h.code);

    headerCodes.forEach((f) => {
      let previousByHeaderCodeValues = previousArray.map((m) => m[f]);
      let currentByHeaderCodeValues = currentArray.map((m) => m[f]);
      let validationResult =
        previousByHeaderCodeValues.length == currentByHeaderCodeValues.length &&
        previousByHeaderCodeValues.every((v, i) => {
          return v == currentByHeaderCodeValues[i];
        });

      if (!validationResult) {
        result = validationResult;
        return;
      }
    });
    return result;
  }

  async doPrivilegedAction(
    action: {
      fn: (param: any) => any;
      icon: string;
      tooltip: string;
      isDisabled: boolean;
      disabledFn?: (param: any) => boolean;
      isPrivileged?: boolean;
      privilege?: string;
    },
    item: any
  ) {
    await this.supervisorService.show(() => {
      action.fn(item);
    }, [action.privilege || '']);
  }

  getKeyListFromMap(keys: Iterable<any>): Array<any> {
    return Array.from(keys);
  }

  clearFilters() {

    if (this.filters.length > 0) {
      let filterColumns = this.filters.reduce(
        (ac, a) => ({ ...ac, [a.code]: '' }),
        {}
      );
      this.filterForm = this.formBuilder.group(filterColumns);
    }

    if (this.groupedFilters.length > 0) {
      let filterColumns = this.groupedFilters.flatMap(f => f.filters).reduce(
        (ac, a) => ({ ...ac, [a.code]: '' }),
        {}
      );
      this.filterForm = this.formBuilder.group(filterColumns);
    }
    this.popOversToHide.forEach(f => f.hide());
    this.filterAction(undefined, undefined, undefined, true);
  }

  getSuccessValue(item: any) {
    if (this.highlightSuccessDangerField.length == 0) {
      return false;

    }
    if (item[this.highlightSuccessDangerField] == undefined) {
      return false;
    }

    return item[this.highlightSuccessDangerField];
  }

  getDangerValue(item: any) {
    if (this.highlightSuccessDangerField.length == 0) {
      return false;

    }
    if (item[this.highlightSuccessDangerField] == undefined) {
      return false;
    }
    return !item[this.highlightSuccessDangerField];
  }

  refresh() {
    this.popOversToHide.forEach(f => f.hide());
    this.filterAction(undefined, undefined, undefined, false);
  }

  addToHide(pop: PopoverDirective) {
    if (!this.popOversToHide.some(s => s.popoverId == pop.popoverId)) {
      this.popOversToHide.push(pop);
    }

  }

  hideOtherPopovers(pop: PopoverDirective) {
    this.popOversToHide.filter(f => f.popoverId != pop.popoverId).forEach(f => f.hide());
    pop.toggle();
  }

  getCurrencyField(item: any, header: ColumnTable) {
    let itemValue = item[header.currencyField];
    itemValue = itemValue || "HNL";
    return `${itemValue} `;
  }

  selecteAllSwitch(header: ColumnTable) {
    const headerIndex = this.headers.findIndex(f => f.code == header.code);
    const value = this.tableForm?.controls[`${header.code}-selectedAllSwitch`].value;
    this.data.content.forEach((f, i) => {
      const control = this.tableForm?.controls[`${header.code}-${i}-${headerIndex}`];
      if (!control?.disabled) {
        f[header.code] = value;
        control?.patchValue(value);
      }
    })

    header.selectAllSwitchFn(this.data, value);
  }

  switchFn(header: ColumnTable, item: any) {
    item[header.code] = !item[header.code];
    header.switchFn(item);
  }

  onSubmitWithError() {
    this.getTableFormInvalid.emit(this.tableForm);
  }

  minusNumber(item: any, header: ColumnTable, itemIndex: number, headerIndex: number) {

    const control = this.tableForm?.controls[`${header.code}-${itemIndex}-${headerIndex}`];
    item[header.code] = item[header.code] - 1;
    control?.patchValue(item[header.code]);

    if (!control?.invalid && !control?.disabled) {
      this.onSubmit();
    }
  }

  plusNumber(item: any, header: ColumnTable, itemIndex: number, headerIndex: number) {
    item[header.code] = item[header.code] + 1;
    const control = this.tableForm?.controls[`${header.code}-${itemIndex}-${headerIndex}`];

    control?.patchValue(item[header.code]);
    if (!control?.invalid && !control?.disabled) {
      this.onSubmit();
    }
  }

  async showModal(filter: FilterTable) {
    const value = await filter.showModalFn();
    if (value && value != '') {
      this.filterForm?.controls[filter.code].patchValue(value);
      this.filterAction();
    }
  }

  doActionfn(action: any, item: any) {
    action.fn(item);
  }

  getTemplate(name: string): TemplateRef<any> | null {
    return this.templates.find((tpl: any) => tpl._declarationTContainer?.localNames?.includes(name)) || null;
  }
}
